import { useMemo } from 'react';

import { supportedTokens } from '@/constants';
import useChainByCurrency, { ChainData } from '@/hooks/useChainByCurrency';

// Type guard to check if chain has valid chainData with name
const hasValidChainData = (
  chain: ChainData
): chain is ChainData & { chainData: NonNullable<ChainData['chainData']> & { name: string } } => {
  return chain.chainData?.name !== undefined && chain.chainData?.name !== null;
};

export const useDistinctTokensChains = () => {
  const { findChainByCurrency } = useChainByCurrency();

  const chains = useMemo(() => {
    return Object.values(supportedTokens)
      .reduce<ChainData[]>((acc, currency) => {
        const chain = findChainByCurrency(currency);

        if (chain?.chainData) {
          if (
            !acc.some((c) => {
              const isSameChainSlug = c.chainSlug === chain.chainSlug;
              const isSameChainName = c.chainData?.name === chain.chainData?.name;

              return isSameChainSlug && isSameChainName;
            })
          ) {
            acc.push(chain);
          }
        }
        return acc;
      }, [])
      .filter(hasValidChainData)
      .toSorted((a, b) => a.chainData.name.localeCompare(b.chainData.name));
  }, [findChainByCurrency]);

  return chains;
};
